import * as React from 'react';
import { find as _find } from 'lodash';
import { Modal } from 'reactstrap';
import { setTimeout } from 'timers';
import { UserModel } from 'franke-trough-dependencies';


export interface UserListDeleteModalProps {
  user: UserModel;
  drilledConfirm: (user: UserModel) => void;
  drilledClose: () => void;
}

export interface UserListDeleteModalState {
  isOpen: boolean; 
}

export class UserListDeleteModal extends React.Component<UserListDeleteModalProps, UserListDeleteModalState> {
  constructor(props: UserListDeleteModalProps) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      isOpen: true,
    });
  }

  componentDidUpdate() {
    if (!this.state.isOpen) {
      this.setState({
        isOpen: true
      });
    }
  }

  public render() {
    const user = this.props.user;

    return (
      <Modal 
        isOpen={this.state.isOpen} 
        backdrop={true}
        className="modal-dialog--small user-delete-modal"
      >
        <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
          {user && (
            <div>
              <h3 className="modal-heading">Confirm deletion</h3>
              <div className="modal-body">
                Do you really want to delete the following user: <br />
                <b>{user.email}</b>
              </div>
              <div className="modal-notice">
                Notice:<br />
                All configurations and orders with this user will&nbsp;remain.
              </div>
              <div className="modal-actions text-center">
                <button 
                  className="btn btn-secondary w-100"
                  onClick={this.handleConfirm}
                >
                  Delete user
                </button>
                <button 
                  className="btn btn-light btn-bordered w-100"
                  onClick={this.toggleModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  }

  private toggleModal(): void {
    this.setState({
      isOpen: false,
    });
    setTimeout(() => this.props.drilledClose(), 151);
  } 

  handleConfirm = (event: any) => {
    if (!this.props.drilledConfirm) { return; }

    const user = this.props.user;

    this.props.drilledConfirm(user);
    this.toggleModal();
  }
}

// export const UserListDeleteModal = connect((state: GlobalPrivateState) => ({
// }))(UserListDeleteModalPartial as any);

export default UserListDeleteModal;